import React from "react";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment-timezone";
import { connect } from "react-redux";
import { debounce } from "lodash";
import map from "lodash/map";
import find from "lodash/find";
import uniq from "lodash/uniq";
import {
  Alert,
  Icon,
  Layout,
  Input,
  Button,
  Table,
  Switch,
  Modal,
  Badge,
  message,
  Tooltip,
  Select,
  Checkbox,
} from "antd";

import classes from "./ApiConfiguration.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getApiConfigurationRequest,
  deleteApiConfigRequest,
  activateApiConfigRequest,
  getSitesRequest,
  apiConfigurationExportDownload,
  apiConfigurationExampleDownload, DCTMSFieldsReferenceDownload, apiFieldsReferenceDownload,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import {
  getActivateRedcapApiConfigPermission,
  getDeleteRedcapApiConfigPermission,
  getUpdateRedcapApiConfigPermission,
  getReadRedcapApiConfigPermission,
  getCreateRedcapApiConfigPermission,
  getRunRedcapApiConfigPermission,
  getActivateDFDiscoverApiConfigPermission,
  getDeleteDFDiscoverApiConfigPermission,
  getUpdateDFDiscoverApiConfigPermission,
  getReadDFDiscoverApiConfigPermission,
  getCreateDFDiscoverApiConfigPermission,
  getRunDFDiscoverApiConfigPermission,
  getUserTimezone,
  getUserShortTimezone,
} from "../../reducers/user/selectors";
import ApiConfigurationForm from "./Form/ApiConfigurationForm";
import ApiImportForm from "./Form/ApiImportForm";
import { documentTypes } from "../../components/DocumentForm/DocumentForm";
import actionTypes from "./actionTypes";
import { withNamespaces } from "react-i18next";
import { v4 as uuidv4 } from "uuid";

const { Content } = Layout;
const { Option } = Select;

const errorLevelColors = {
  none: "#52c41a",
  low: "#c4c400",
  medium: "#c49904",
  high: "#ff2702",
  critical: "#c40200",
};

const logResultTypes = {
  success: "#52c41a",
  error: "#f00",
  info: "#04c49e",
  debug: "#fdf39a",
};

class ApiConfiguration extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      apiConfigurations: [],
      nameSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      sites: [],
      site: null,
      filter: null,
      order: "desc",
      currentPage: 1,
      total: 1,
      pageSize: 25,
      eventVisibleDropdown: false,
      sortedInfo: {},
      apiConfigurationEdit: null,
      filterBy: [],
      filterValue: [],
      filtersBy: [], // be default hide all data read logs like "sites viewed"
      filtersValue: [], // or permissions viewed, these are moved to log level info
      approvedSelected: null,
      includeListEvent: true,
      shiftDown: false,
      checkedItems: [],
      apiConfigurationDetails: null,
      activeTypes: [],
      api_mapping_dicts: null,
      isApiImport: false,
    };
  }

  handleKeyDown = (event) => {
    if (event.keyCode === 16) {
      this.setState({
        shiftDown: true,
      });
    }
  };

  handleKeyUp = (event) => {
    if (event.keyCode === 16) {
      this.setState({
        shiftDown: false,
      });
    }
  };

  async componentDidMount() {
    this.onNameSearch();

    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }

    document.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener("keyup", this.handleKeyUp);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("keyup", this.handleKeyUp);
  }

  onNameSearch = async (value) => {
    this.setState(
      { nameSearch: value, filter: null, site: null, currentPage: 1 },
      this.getApiConfiguration
    );
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  getApiConfiguration = debounce(async function (
    page = this.state.currentPage,
    per_page = this.state.pageSize,
    refreshDicts
  ) {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getApiConfigurationRequest({
        nameSearch: this.state.nameSearch,
        order_direction: this.state.order,
        page,
        per_page,
        order_column: get(this.state, "sortedInfo.columnKey"),
        filter_by: this.state.filtersBy,
        filter_value: this.state.filtersValue,
        filter_approve: this.state.approvedSelected,
        hide_apiConfiguration_log_type: this.state.includeListEvent,
      });

      if (Array.isArray(data.data)) {
        this.setState({
          checkedItems: [],
        });

        this.setState({
          apiConfigurations: data.data,
          total: data.total_pages * per_page,
          currentPage: page,
        });
      } else {
        this.setState({
          apiConfigurations: [data],
          total: 1 * per_page,
          currentPage: page,
        });
      }

      if (refreshDicts) {
        this.setState({
          api_mapping_dicts: find(
            data.data,
            ({ id }) => id === this.state.api_mapping_dicts.id
          ),
        });
      }
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        apiConfigurations: [],
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  },
  500);

  clearFilters = () => {
    this.setState(
      {
        nameSearch: null,
        site: null,
        filter: null,
        filterValue: null,
        filterBy: null,
        sortedInfo: null,
        approvedSelected: null,
        currentPage: 1,
      },
      this.getApiConfiguration
    );
  };

  canDoActionForApiType = (apiType, action) => {
    const permissions = [
        ['run', 'redcap', 'getRunRedcapApiConfigPermission'],
        ['delete', 'redcap', 'getDeleteRedcapApiConfigPermission'],
        ['activate', 'redcap', 'getActivateRedcapApiConfigPermission'],
        ['update', 'redcap', 'getUpdateRedcapApiConfigPermission'],
        ['read', 'redcap', 'getReadRedcapApiConfigPermission'],
        ['create', 'redcap', 'getCreateRedcapApiConfigPermission'],

        ['run', 'dfdiscover', 'getRunDFDiscoverApiConfigPermission'],
        ['delete', 'dfdiscover', 'getDeleteDFDiscoverApiConfigPermission'],
        ['activate', 'dfdiscover', 'getActivateDFDiscoverApiConfigPermission'],
        ['update', 'dfdiscover', 'getUpdateDFDiscoverApiConfigPermission'],
        ['read', 'dfdiscover', 'getReadDFDiscoverApiConfigPermission'],
        ['create', 'dfdiscover', 'getCreateDFDiscoverApiConfigPermission'],
      ];

    for (let i = 0; i < permissions.length; i++) {
        let permData = permissions[i];
        let act = permData[0];
        let typ = permData[1];
        let cb = permData[2];

        if (typ === apiType && act === action){
          return get(this.props, cb, false);
        }
      }
    return false;
  };

  handleFilterChange = (index) => (value) => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);
      filtersBy[index] = value;
      delete filtersValue[index];
      return { filtersBy, filtersValue };
    });
  };

  handleFilterValueChange = (index) =>
    debounce((value) => {
      this.setState((state) => {
        const filtersValue = cloneDeep(state.filtersValue);
        filtersValue[index] = value;
        return { filtersValue, currentPage: 1 };
      }, this.getApiConfiguration);
    }, 500);

  clearFilter = (index) => () => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);

      filtersBy.splice(index, 1);
      filtersValue.splice(index, 1);

      return { filtersBy, filtersValue, currentPage: 1 };
    }, this.getApiConfiguration);
  };

  onSelectApprovedStatus = (approvedStatusType) => () => {
    let status;
    const { approvedSelected } = this.state;

    if (approvedSelected === null && approvedStatusType === "approved") {
      status = false;
    }
    if (approvedSelected === true && approvedStatusType === "approved") {
      status = false;
    }
    if (approvedSelected === false && approvedStatusType === "approved") {
      status = null;
    }

    if (approvedSelected === null && approvedStatusType === "unapproved") {
      status = true;
    }
    if (approvedSelected === false && approvedStatusType === "unapproved") {
      status = true;
    }
    if (approvedSelected === true && approvedStatusType === "unapproved") {
      status = null;
    }

    this.setState(
      (_) => ({ approvedSelected: status, currentPage: 1 }),
      this.getApiConfiguration
    );
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getApiConfiguration(pagination.current, pagination.pageSize)
    );
  };

  onAuditEdit = (apiConfiguration) => () => {
    this.setState({ apiConfigurationEdit: apiConfiguration });
  };

  onAuditEditHide = () => {
    this.setState({ apiConfigurationEdit: null });
  };

  onAuditEditSubmit = () => {
    this.setState({ apiConfigurationEdit: null }, this.getApiConfiguration);
  };

  onViewAuditDetails = (apiConfiguration) => () => {
    this.setState({ apiConfigurationDetails: apiConfiguration });
  };

  onCloseAuditDetails = () => {
    this.setState({ apiConfigurationDetails: null });
  };

  onSwitchApiConfigActivation = (id, state) => async () => {
    try {
      if (state === "active") {
        await deleteApiConfigRequest(id);
      } else {
        await activateApiConfigRequest(id);
      }

      message.success(this.props.i18n.t("Saved"));

      this.getApiConfiguration();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error("Error");
      console.log(e);
    }
  };

  renderFilterItem = (index = this.state.filtersBy.length) => {
    const { filtersBy, filtersValue, sites } = this.state;

    return (
      <div className={classes.wrapperFilterItem} key={filtersBy[index]}>
        <div className={classes.searchWrapper}>
          <div className={classes.searchWrapperFilter}>
            <label className={classes.searchWrapperFilterItem}>
              <b className={classes.searchWrapperLabel}>Filter by</b>
              <Select
                onChange={this.handleFilterChange(index)}
                value={filtersBy[index]}
                style={{ width: "100%" }}
                placeholder={this.props.i18n.t("Select")}
              >
                <Option
                  value="action_type"
                  disabled={filtersBy.includes("action_type")}
                >
                  {this.props.i18n.t("NamespaceApiConfiguration:Action type")}
                </Option>
                <Option
                  value="error_level"
                  disabled={filtersBy.includes("error_level")}
                >
                  {this.props.i18n.t("NamespaceApiConfiguration:Error level")}
                </Option>
                <Option value="result" disabled={filtersBy.includes("result")}>
                  {this.props.i18n.t("NamespaceApiConfiguration:Result")}
                </Option>
                <Option
                  value="log_level"
                  disabled={filtersBy.includes("log_level")}
                >
                  {this.props.i18n.t("NamespaceApiConfiguration:Log Level")}
                </Option>
                <Option value="state" disabled={filtersBy.includes("state")}>
                  {this.props.i18n.t("State")}
                </Option>
                <Option value="site" disabled={filtersBy.includes("site")}>
                  {this.props.i18n.t("Site")}
                </Option>
                <Option value="user" disabled={filtersBy.includes("user")}>
                  {this.props.i18n.t("User")}
                </Option>
                <Option
                  value="apiConfiguration_log_email_type"
                  disabled={filtersBy.includes(
                    "apiConfiguration_log_email_type"
                  )}
                >
                  {this.props.i18n.t(
                    "NamespaceApiConfiguration:Audit log email type"
                  )}
                </Option>
              </Select>
            </label>
          </div>

          {filtersBy[index] === "action_type" && (
            <label className={classes.searchWrapperFilterItem}>
              <b className={classes.searchWrapperLabel}>
                {this.props.i18n.t("NamespaceApiConfiguration:Result")}
              </b>
              <Select
                mode="multiple"
                showSearch
                onChange={this.handleFilterValueChange(index)}
                value={filtersValue[index]}
                style={{ width: "100%" }}
                placeholder={this.props.i18n.t("Select")}
              >
                {uniq([
                  ...Object.keys(actionTypes),
                  ...this.state.activeTypes,
                ]).map((key) => (
                  // {Object.keys(actionTypes).map((key) => (
                  <Option key={key} value={key}>
                    {key}
                  </Option>
                ))}
              </Select>
            </label>
          )}

          {filtersBy[index] === "error_level" && (
            <label className={classes.searchWrapperFilterItem}>
              <b className={classes.searchWrapperLabel}>
                {this.props.i18n.t("NamespaceApiConfiguration:Result")}
              </b>
              <Select
                mode="multiple"
                onChange={this.handleFilterValueChange(index)}
                value={filtersValue[index]}
                style={{ width: "100%" }}
                placeholder={this.props.i18n.t("Select")}
              >
                <Option value="none">{this.props.i18n.t("None")}</Option>
                <Option value="low">
                  {this.props.i18n.t("NamespaceApiConfiguration:Low")}
                </Option>
                <Option value="medium">
                  {this.props.i18n.t("NamespaceApiConfiguration:Medium")}
                </Option>
                <Option value="high">
                  {this.props.i18n.t("NamespaceApiConfiguration:High")}
                </Option>
                <Option value="critical">
                  {this.props.i18n.t("NamespaceApiConfiguration:Critical")}
                </Option>
              </Select>
            </label>
          )}

          {filtersBy[index] === "result" && (
            <label className={classes.searchWrapperFilterItem}>
              <b className={classes.searchWrapperLabel}>
                {this.props.i18n.t("NamespaceApiConfiguration:Result")}
              </b>
              <Select
                onChange={this.handleFilterValueChange(index)}
                value={filtersValue[index]}
                style={{ width: "100%" }}
                placeholder={this.props.i18n.t("Select")}
              >
                <Option value="success">{this.props.i18n.t("Success")}</Option>
                <Option value="failure">
                  {this.props.i18n.t("NamespaceApiConfiguration:Failure")}
                </Option>
                <Option value="info">
                  {this.props.i18n.t("NamespaceApiConfiguration:Info")}
                </Option>
                <Option value="debug">
                  {this.props.i18n.t("NamespaceApiConfiguration:Debug")}
                </Option>
              </Select>
            </label>
          )}

          {filtersBy[index] === "log_level" && (
            <label className={classes.searchWrapperFilterItem}>
              <b className={classes.searchWrapperLabel}>
                {this.props.i18n.t("NamespaceApiConfiguration:Log Level")}
              </b>
              <Select
                onChange={this.handleFilterValueChange(index)}
                value={filtersValue[index]}
                style={{ width: "100%" }}
                placeholder={this.props.i18n.t("Select")}
              >
                <Option value="actions">
                  {this.props.i18n.t("NamespaceApiConfiguration:Actions")}
                </Option>
                <Option value="info">
                  {this.props.i18n.t("NamespaceApiConfiguration:Info")}
                </Option>
                <Option value="debug">
                  {this.props.i18n.t("NamespaceApiConfiguration:Debug")}
                </Option>
              </Select>
            </label>
          )}

          {filtersBy[index] === "state" && (
            <label className={classes.searchWrapperFilterItem}>
              <b className={classes.searchWrapperLabel}>
                {this.props.i18n.t("State")}
              </b>
              <Select
                onChange={this.handleFilterValueChange(index)}
                value={filtersValue[index]}
                style={{ width: "100%" }}
                placeholder={this.props.i18n.t("Select")}
              >
                <Option value="active">{this.props.i18n.t("Active")}</Option>
                <Option value="inactive">
                  {this.props.i18n.t("Inactive")}
                </Option>
              </Select>
            </label>
          )}

          {filtersBy[index] === "apiConfiguration_log_email_type" && (
            <label className={classes.searchWrapperFilterItem}>
              <b className={classes.searchWrapperLabel}>
                {this.props.i18n.t("NamespaceApiConfiguration:Result")}
              </b>
              <Select
                onChange={this.handleFilterValueChange(index)}
                value={filtersValue[index]}
                style={{ width: "100%" }}
                placeholder={this.props.i18n.t("Select")}
              >
                <Option value="sent">{this.props.i18n.t("Sent")}</Option>
                <Option value="not_sent">
                  {this.props.i18n.t("NamespaceApiConfiguration:Not sent")}
                </Option>
              </Select>
            </label>
          )}

          {filtersBy[index] === "site" && (
            <label className={classes.searchWrapperFilterItem}>
              <b className={classes.searchWrapperLabel}>
                {this.props.i18n.t("Site")}
              </b>
              <Select
                mode="multiple"
                onChange={this.handleFilterValueChange(index)}
                value={filtersValue[index]}
                style={{ width: "100%" }}
                placeholder={this.props.i18n.t("Select")}
              >
                {sites.map((site) => (
                  <Option key={site.id} value={site.id}>
                    {site.name}
                  </Option>
                ))}
                <Option value={null}>{this.props.i18n.t("None")}</Option>
              </Select>
            </label>
          )}

          {filtersBy[index] === "user" && (
            <label className={classes.searchWrapperFilterItem}>
              <b className={classes.searchWrapperLabel}>
                {this.props.i18n.t("User")}
              </b>
              <Input
                onChange={(e) =>
                  this.handleFilterValueChange(index)(e.target.value)
                }
                style={{ width: "100%" }}
                placeholder={this.props.i18n.t("User")}
              />
            </label>
          )}

          {filtersValue[index] && (
            <span
              className={classes.clearButton}
              onClick={this.clearFilter(index)}
            >
              {this.props.i18n.t("Remove")}
            </span>
          )}
        </div>
      </div>
    );
  };


  exportApiConfiguration = async () => {
    try {
      this.setState(() => ({
        loadingExport: true,
      }));

      let data = null;

      const response = await apiConfigurationExportDownload(
        this.state.api_mapping_dicts.id
      );
      data = response.data;

      const blob = new Blob([data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `api-configuration-export-${this.state.api_mapping_dicts.id}.csv`;
      link.click();
    } catch (e) {
      message.error("Error");
      console.log(e);
    }

    this.setState(() => ({
      loadingExport: false,
    }));
  };

  downloadExampleApiConfiguration = async () => {
    try {
      this.setState(() => ({
        loadingDownloadExample: true,
      }));

      let data = null;

      const response = await apiConfigurationExampleDownload();
      data = response.data;

      const blob = new Blob([data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `api-configuration-example-${this.state.api_mapping_dicts.id}.csv`;
      link.click();
    } catch (e) {
      message.error("Error");
      console.log(e);
    }

    this.setState(() => ({
      loadingDownloadExample: false,
    }));
  };

  apiFieldsReference = async () => {
    try {
      this.setState(() => ({
        loadingApiReference: true,
      }));

      let data = null;

      const response = await apiFieldsReferenceDownload(
        this.state.api_mapping_dicts.id
      );
      data = response.data;

      const blob = new Blob([data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);

      // todo add api name
      link.download = `api-fields-reference-${this.state.api_mapping_dicts.id}.json`;
      link.click();
    } catch (e) {
      message.error("Error");
      console.log(e);
    }

    this.setState(() => ({
      loadingApiReference: false,
    }));
  };

  DCTMSFieldsReference = async () => {
    try {
      this.setState(() => ({
        loadingDctmsReference: true,
      }));

      let data = null;

      const response = await DCTMSFieldsReferenceDownload(
        this.state.api_mapping_dicts.id
      );
      data = response.data;

      const blob = new Blob([data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      // todo add trial name
      link.download = `dctms-trial-fields-reference.json`;
      link.click();
    } catch (e) {
      message.error("Error");
      console.log(e);
    }

    this.setState(() => ({
      loadingDctmsReference: false,
    }));
  };

  render() {
    const {
      errorMessage,
      isLoading,
      responseMessage,
      nameSearch,
      apiConfigurations,
      currentPage,
      total,
      pageSize,
      apiConfigurationEdit,
      sortedInfo,
      filtersBy,
      filtersValue,
      sites,
      approvedSelected,
      includeListEvent,
      checkedItems,
      shiftDown,
      apiConfigurationDetails,
    } = this.state;

    const logNotAllowedForSelection = (primaryLog, log) =>
      primaryLog && primaryLog.reviewed !== log.reviewed;

    const columnsApiMapping = [
      {
        dataIndex: "cohort",
        key: "cohort",
        title: "COHORT",
      },
      {
        dataIndex: "dctms_path",
        key: "dctms_path",
        title: "DCTMS path",
      },
      {
        dataIndex: "dctms_field_type",
        key: "dctms_field_type",
        title: "DCTMS field type",
      },
      {
        dataIndex: "api_path",
        key: "api_path",
        title: "API path",
      },
      {
        dataIndex: "api_field_type",
        key: "api_field_type",
        title: "API field type",
      },
      {
        dataIndex: "value_map",
        key: "value_map",
        title: "Value map",
      },
      {
        dataIndex: "direction",
        key: "direction",
        title: "Direction",
      },
      {
        dataIndex: "dctms_field_spec",
        key: "dctms_field_spec",
        title: "DCTMS field spec",
      },
      {
        dataIndex: "api_field_spec",
        key: "api_field_spec",
        title: "API field spec",
      },
      {
        dataIndex: "custom_processor_function",
        key: "custom_processor_function",
        title: "Custom processor function",
      },
    ];

    const columns = [
      {
        dataIndex: "state",
        key: "state",
        title: this.props.i18n.t("NamespaceApiConfiguration:State"),
        render: (val, record) => (
          <div className={classes.nameAuditWrapper}>
            <div style={{ width: "86px" }}>
              <Badge
                count={record.state}
                style={{
                  backgroundColor:
                    record.state === "active" ? "#52c41a" : "#777",
                }}
              />
            </div>
          </div>
        ),
      },
      {
        dataIndex: "name",
        key: "name",
        title: this.props.i18n.t("NamespaceApiConfiguration:Name"),
      },
      {
        dataIndex: "api_service_type",
        key: "api_service_type",
        title: this.props.i18n.t("NamespaceApiConfiguration:API Service Type"),
      },
      {
        dataIndex: "url",
        key: "url",
        title: this.props.i18n.t("NamespaceApiConfiguration:URL"),
      },
      {
        dataIndex: "api_action_types",
        key: "api_action_types",
        title: this.props.i18n.t("NamespaceApiConfiguration:API Actions"),
        render: (val, row) => (
          <div>
            {map(val, (item, key) => <div key={key}><b>{item}</b></div>)}
            {row.mapped_fields_count ? (
              <div>
                <i>{this.props.i18n.t("Mapped fields")}: <b>{row.mapped_fields_count}</b></i>
              </div>
            ) : ('')}
          </div>
        ),
      },
      {
        dataIndex: "scheduled_time",
        key: "scheduled_time",
        title: this.props.i18n.t("NamespaceApiConfiguration:Scheduled Time"),
        render: (val, row) => (
          <div>
            {val} {row.time_zone}
          </div>
        ),
      },
      {
        dataIndex: "last_processed_at",
        key: "last_processed_at",
        title: this.props.i18n.t("NamespaceApiConfiguration:Last Processed At"),
        render: (val, row) =>
          val ? (
            <div>
              {val} {row.time_zone}
            </div>
          ) : (
            <div />
          ),
      },
      {
        dataIndex: "id",
        key: "id_actions",
        title: this.props.i18n.t("Actions"),
        render: (val, apiConfiguration) => (
          <div className={classes.actions}>
            {this.canDoActionForApiType(apiConfiguration.api_service_type, 'update') && (
              <Tooltip
                placement="topLeft"
                title={this.props.i18n.t(
                  "NamespaceApiConfiguration:Edit Settings"
                )}
              >
                <Icon
                  type="edit"
                  theme="filled"
                  className={classes.iconEdit}
                  onClick={this.onAuditEdit(apiConfiguration)}
                />
              </Tooltip>
            )}
            &nbsp; &nbsp;

            {this.canDoActionForApiType(apiConfiguration.api_service_type, 'update') && (
              <Tooltip
                placement="topLeft"
                title={this.props.i18n.t(
                  "NamespaceApiConfiguration:Field mapping"
                )}
              >
                <Icon
                  type="api"
                  theme={apiConfiguration.mapped_fields_count ? ("filled") : ("outlined")}
                  className={classes.iconEdit}
                  onClick={() => {
                    this.setState({
                      api_mapping_dicts: apiConfiguration,
                    });
                  }}
                />
              </Tooltip>
            )}
            &nbsp; &nbsp;
            <div style={{ width: "60px", display: "flex" }}>
              <div>
                <b className={classes.switchLabel}>
                  {this.props.i18n.t("State")}
                </b>
                <br />
                <Tooltip
                  placement="topLeft"
                  title={this.props.i18n.t(
                    "NamespaceApiConfiguration:Activate / Deactivate"
                  )}
                >
                  <Switch
                    disabled={
                      (!this.canDoActionForApiType(apiConfiguration.api_service_type, 'activate') &&
                        apiConfiguration.state === "inactive") ||
                      (!this.canDoActionForApiType(apiConfiguration.api_service_type, 'delete') &&
                        apiConfiguration.state === "active")
                    }
                    className={classes.reactivateBtn}
                    checked={apiConfiguration.state === "active"}
                    onChange={this.onSwitchApiConfigActivation(
                      val,
                      apiConfiguration.state
                    )}
                  />
                </Tooltip>
              </div>
            </div>
          </div>
        ),
      },
    ];

    return (
      <div>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("API Configuration")}
            </h3>

            {(this.props.getCreateRedcapApiConfigPermission || this.props.getCreateDFDiscoverApiConfigPermission) && (
              <div>
                <Button
                  type="primary"
                  onClick={() => {
                    this.setState({ apiConfigurationEdit: {} });
                  }}
                >
                  {this.props.i18n.t("Add new configuration")}
                </Button>
              </div>
            )}

            {/*<div className={classes.searchWrapper}>
              <label className={classes.searchWrapperSearch}>
                <b className={classes.searchWrapperLabel}>
                  {this.props.i18n.t("SEARCH")}
                </b>
                <Input.Search
                  enterButton={this.props.i18n.t("Search")}
                  size="large"
                  onSearch={this.onNameSearch}
                  value={nameSearch}
                  onChange={this.onNameChange}
                  style={{ maxWidth: "500px" }}
                />
              </label>

              <span className={classes.clearButton} onClick={this.clearFilters}>
                {this.props.i18n.t("Clear")}
              </span>
            </div>

            <h4 className="headline-default">{this.props.i18n.t("Filter")}</h4>
            <div className={classes.wrapperFilters}>
              <div className={classes.searchWrapperFilterItemApprove}>
                <Checkbox
                  onChange={this.onSelectApprovedStatus("approved")}
                  checked={
                    approvedSelected === null || approvedSelected === true
                  }
                >
                  {this.props.i18n.t("NamespaceApiConfiguration:Reviewed")}
                </Checkbox>
                <Checkbox
                  onChange={this.onSelectApprovedStatus("unapproved")}
                  checked={!approvedSelected}
                >
                  {this.props.i18n.t("NamespaceApiConfiguration:Unreviewed")}
                </Checkbox>
                <Checkbox
                  onChange={(e) =>
                    this.setState(
                      { includeListEvent: e.target.checked, currentPage: 1 },
                      this.getApiConfiguration
                    )
                  }
                  checked={includeListEvent}
                >
                  {this.props.i18n.t(
                    "NamespaceApiConfiguration:Skip apiConfiguration log actions"
                  )}
                </Checkbox>
              </div>

              {filtersBy.map((_, index) => this.renderFilterItem(index))}

              {filtersBy.length === filtersValue.length &&
                filtersBy.length !== 5 &&
                this.renderFilterItem()}
            </div>*/}

            {errorMessage && <Alert type="error" message={errorMessage} />}

            {responseMessage && (
              <Alert type="success" message={responseMessage} />
            )}

            <div className={classes.tableWrapper}>
              <Table
                columns={columns}
                dataSource={apiConfigurations}
                loading={isLoading}
                rowKey="id"
                onChange={this.handleTableChange}
                className={classes.table}
                pagination={{
                  onShowSizeChange: (current, size) => {
                    this.setState({ pageSize: size });
                  },
                  current: currentPage,
                  total,
                  pageSize,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "25", "50", "100"],
                  position: "both",
                }}
              />
            </div>

            {/*{isLoading && <Icon type="loading" />}*/}

            <Modal
              visible={!!apiConfigurationEdit}
              onCancel={this.onAuditEditHide}
              footer={null}
            >
              {apiConfigurationEdit && (
                <ApiConfigurationForm
                  values={apiConfigurationEdit}
                  isNew={apiConfigurationEdit && !apiConfigurationEdit.id}
                  onSubmit={this.onAuditEditSubmit}
                  onCancel={this.onAuditEditHide}
                  getApiConfiguration={() => {
                    this.getApiConfiguration();
                  }}
                />
              )}
            </Modal>
            <Modal
              visible={!!this.state.api_mapping_dicts}
              onCancel={() => {
                this.setState({ api_mapping_dicts: null });
              }}
              footer={null}
              width="90%"
            >
              {this.state.api_mapping_dicts && (
                <div className={classes.tableWrapper}>
                  <Modal
                    visible={!!this.state.isApiImport}
                    onCancel={() => {
                      this.setState({ isApiImport: false });
                    }}
                    footer={null}
                  >
                    <ApiImportForm
                      id={this.state.api_mapping_dicts.id}
                      onSubmit={() => {
                        this.setState({ isApiImport: false }, () => {
                          this.getApiConfiguration(
                            this.state.currentPage,
                            this.state.pageSize,
                            true
                          );
                        });
                      }}
                      onCancel={() => {
                        this.setState({ isApiImport: false });
                      }}
                    />
                  </Modal>

                  <div className={classes.actionWrapper}>
                    {this.canDoActionForApiType(this.state.api_mapping_dicts.api_service_type, 'update')  && (
                      <Button
                        type="primary"
                        onClick={() => {
                          this.setState({ isApiImport: true });
                        }}
                      >
                        {this.props.i18n.t("Import API mapping")}
                      </Button>
                    )}
                    &nbsp;&nbsp;
                    {this.canDoActionForApiType(this.state.api_mapping_dicts.api_service_type, 'read') && (
                      <Button
                        type="primary"
                        onClick={() => {
                          this.exportApiConfiguration();
                        }}
                        loading={this.state.loadingExport}
                      >
                        {this.props.i18n.t("Export API mapping")}
                      </Button>
                    )}
                    &nbsp;&nbsp;
                    <Button
                      type="primary"
                      onClick={() => {
                        this.downloadExampleApiConfiguration();
                      }}
                      loading={this.state.loadingDownloadExample}
                    >
                      {this.props.i18n.t("Download Example")}
                    </Button>
                    &nbsp;&nbsp;
                    <Button
                      type="default"
                      onClick={() => {
                        this.apiFieldsReference();
                      }}
                      loading={this.state.loadingApiReference}
                    >
                      {this.props.i18n.t("API fields JSON")}
                    </Button>
                    &nbsp;&nbsp;
                    <Button
                      type="default"
                      onClick={() => {
                        this.DCTMSFieldsReference();
                      }}
                      loading={this.state.loadingDctmsReference}
                    >
                      {this.props.i18n.t("DCTMS fields JSON")}
                    </Button>

                    &nbsp;&nbsp;
                    <span>Mappings are <b><u>SEMICOLON</u></b> <b>";"</b> separated csv.</span>
                  </div>

                    {this.canDoActionForApiType(this.state.api_mapping_dicts.api_service_type, 'read') && (
                      <Table
                        columns={columnsApiMapping}
                        dataSource={this.state.api_mapping_dicts.api_mapping_dicts}
                        rowKey={() => uuidv4()}
                        pagination={false}
                      />
                    )}
                </div>
              )}
            </Modal>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  getRunRedcapApiConfigPermission: getRunRedcapApiConfigPermission(state),
  getDeleteRedcapApiConfigPermission: getDeleteRedcapApiConfigPermission(state),
  getActivateRedcapApiConfigPermission: getActivateRedcapApiConfigPermission(
    state
  ),
  getUpdateRedcapApiConfigPermission: getUpdateRedcapApiConfigPermission(state),
  getReadRedcapApiConfigPermission: getReadRedcapApiConfigPermission(state),
  getCreateRedcapApiConfigPermission: getCreateRedcapApiConfigPermission(state),

  getRunDFDiscoverApiConfigPermission: getRunDFDiscoverApiConfigPermission(state),
  getDeleteDFDiscoverApiConfigPermission: getDeleteDFDiscoverApiConfigPermission(state),
  getActivateDFDiscoverApiConfigPermission: getActivateDFDiscoverApiConfigPermission(
    state
  ),
  getUpdateDFDiscoverApiConfigPermission: getUpdateDFDiscoverApiConfigPermission(state),
  getReadDFDiscoverApiConfigPermission: getReadDFDiscoverApiConfigPermission(state),
  getCreateDFDiscoverApiConfigPermission: getCreateDFDiscoverApiConfigPermission(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(ApiConfiguration))
);



// WEBPACK FOOTER //
// ./src/containers/ApiConfiguration/ApiConfiguration.js